
import { useTranslation } from 'react-i18next';

export const Translator = ({ path, values }: { path: string; values?: Record<string, any> }): React.ReactElement => {
  const { t } = useTranslation();

  return <>{t(path, values)} </>;
};

export default Translator
